<template>
    <b-table-lite
        bordered
        no-border-collapse
        striped
        outlined
        :items="items"
        :fields="fields"
        sticky-header="400px"
        table-class="table-va-middle"
        class="shadow-sm"
    />
</template>

<script>
import { PRISMS_Y_AXES } from "@/modules/common/settings";
import format from "@/utils/format";

const numberFormater = value => format(value);

export default {
    name: "BPrismTable",
    props: {
        prisms: {
            type: Array,
            required: true
        },
        solutionKey: {
            type: String,
            default: "Solution"
        }
    },
    computed: {
        fields() {
            return [
                {
                    key: "name",
                    label: "Prisma"
                },
                {
                    key: "easting_diff",
                    label: `${PRISMS_Y_AXES.easting_diff.label} (${PRISMS_Y_AXES.easting_diff.unit})`,
                    formatter: numberFormater
                },
                {
                    key: "northing_diff",
                    label: `${PRISMS_Y_AXES.northing_diff.label} (${PRISMS_Y_AXES.northing_diff.unit})`,
                    formatter: numberFormater
                },
                {
                    key: "height_diff",
                    label: `${PRISMS_Y_AXES.height_diff.label} (${PRISMS_Y_AXES.height_diff.unit})`,
                    formatter: numberFormater
                },
                {
                    key: "total_diff",
                    label: `${PRISMS_Y_AXES.total_diff.label} (${PRISMS_Y_AXES.total_diff.unit})`,
                    formatter: numberFormater
                },
                {
                    key: "across_stream_line_diff",
                    label: `${PRISMS_Y_AXES.across_stream_line_diff.label} (${PRISMS_Y_AXES.across_stream_line_diff.unit})`,
                    formatter: numberFormater
                },
                {
                    key: "stream_line_diff",
                    label: `${PRISMS_Y_AXES.stream_line_diff.label} (${PRISMS_Y_AXES.stream_line_diff.unit})`,
                    formatter: numberFormater
                }
            ].map(item => ({
                ...item,
                label: item.label
                    .replace("Variação ", "")
                    .replace("na ", "")
                    .replace("direção ", "")
                    .replace(/(^|\s)\S/g, t => t.toUpperCase())
            }));
        },
        items() {
            return this.prisms.map(prism => ({
                name: prism.ID,
                across_stream_line_diff:
                    prism[this.solutionKey][3] *
                    PRISMS_Y_AXES.across_stream_line_diff.rate,
                stream_line_diff:
                    prism[this.solutionKey][4] *
                    PRISMS_Y_AXES.stream_line_diff.rate,
                height_diff:
                    prism[this.solutionKey][2] * PRISMS_Y_AXES.height_diff.rate,
                easting_diff:
                    prism[this.solutionKey][0] *
                    PRISMS_Y_AXES.easting_diff.rate,
                northing_diff:
                    prism[this.solutionKey][1] *
                    PRISMS_Y_AXES.northing_diff.rate,
                total_diff:
                    prism[this.solutionKey][5] * PRISMS_Y_AXES.total_diff.rate
            }));
        }
    }
};
</script>
